import { Decimal } from "decimal.js";
/**
 * Exact decimal arithmetic for the shared pricing module.
 *
 * Money is a plain `number` on the wire, but a line's extension must never be
 * computed with float `*` and `Math.round(n * 100) / 100`. The float product
 * of two decimal amounts lands just below or just above a half cent
 * (5.85 x 27.30 is 159.70499999999998, not 159.705), so float rounding sends
 * the same half cent up on one line and down on the next. These helpers read
 * each `number` as the decimal it prints as, compute exactly, and round
 * `ROUND_HALF_UP` (half away from zero), the rule the backend's own Decimal
 * money helpers use (`toDecimalPlaces(2, ROUND_HALF_UP)`).
 *
 * A private clone of the constructor, so a consumer's global `Decimal.set`
 * (the frontend configures its own) can never change how a price rounds.
 */
export const PricingDecimal = Decimal.clone({
    precision: 20,
    rounding: Decimal.ROUND_HALF_UP,
});
/** Rounds to 2 decimal places (whole cents), half away from zero. */
export function round2(value) {
    return new PricingDecimal(value).toDecimalPlaces(2, PricingDecimal.ROUND_HALF_UP);
}
/** `round2`, returned as a plain `number`. */
export function round2ToNumber(value) {
    return round2(value).toNumber();
}
